import { useApiQuery } from '@/shared/hooks/useApi';
import { api } from '@/shared/services/api';

import { ArtistCategory, ArtistItem } from '../types/productTypes';

const fetchArtistCategories = async () => {
  return api.get<{ artistCategoryList: ArtistCategory[] }>(
    '/api/v1/artist/category',
  );
};

const fetchArtistList = async (artistCategoryId: number) => {
  return api.get<{ artistList: ArtistItem[] }>(
    `/api/v1/artist?artistCategoryId=${artistCategoryId}`,
  );
};

export const useArtistCategories = () => {
  return useApiQuery(['artist-categories'], fetchArtistCategories, {
    staleTime: 1000 * 60 * 10,
  });
};

export const useArtistList = (artistCategoryId: number | null) => {
  return useApiQuery(
    ['artist-list', artistCategoryId ?? ''],
    () => fetchArtistList(artistCategoryId!),
    {
      enabled: artistCategoryId !== null,
      staleTime: 1000 * 60 * 5,
    },
  );
};
